"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bizExclusionReducer = exports.bizExclusionActions = exports.TYPES = exports.INIT_STATE = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'BizExclusion';

// アクションタイプ
const TYPES = exports.TYPES = {
  // 検索条件変更
  CHANGE_CONDITION: PREFIX + 'ChangeCondtion',
  // 検索結果を設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // 組織名の表示切替
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // 対象外設定変更
  CHANGE_EXCLUSION: PREFIX + 'ChangeExclusion',
  // 対象外設定変更（ページ全て）
  CHANGE_EXCLUSION_ALL: PREFIX + 'ChangeExclusionAll',
  // ページングリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 全状態を初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// 初期状態
const INIT_STATE = exports.INIT_STATE = {
  conditions: {
    userNm: '',
    kaishaCd: '',
    soshikiCd: '',
    target: true,
    nonTarget: true,
    seconded: true,
    nonSeconded: true
  },
  searchResult: [],
  listState: {},
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  showAll: false
};
const bizExclusionActions = exports.bizExclusionActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      resultData: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_EXCLUSION]: function () {
    return {
      userId: arguments.length <= 0 ? undefined : arguments[0],
      exclusion: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_EXCLUSION_ALL]: function () {
    return {
      exclusion: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.CLEAR, TYPES.RESET_PAGING);
const bizExclusionReducer = exports.bizExclusionReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => {
    let newListState = {};
    action.payload.resultData.forEach(data => {
      newListState[data.kaishaCd + data.shainId] = {
        isChange: false,
        kaishaCd: data.kaishaCd,
        shainId: data.shainId,
        exclusion: data.exclusion ? true : false,
        exclusionOrg: data.exclusion ? true : false
      };
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: action.payload.resultData,
      listState: newListState
    });
  },
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      showAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_EXCLUSION]: (state, action) => {
    let newListState = Object.assign({}, state.listState);
    const {
      exclusionOrg
    } = newListState[action.payload.userId];
    newListState[action.payload.userId] = _objectSpread(_objectSpread({}, newListState[action.payload.userId]), {}, {
      isChange: action.payload.exclusion !== exclusionOrg,
      exclusion: action.payload.exclusion,
      exclusionOrg: exclusionOrg
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listState: newListState
    });
  },
  [TYPES.CHANGE_EXCLUSION_ALL]: (state, action) => {
    let tagetList = state.searchResult.slice(state.paging.currentPage * state.paging.viewNum, state.paging.currentPage * state.paging.viewNum + state.paging.viewNum);
    let newListState = Object.assign({}, state.listState);
    tagetList.forEach(data => {
      const {
        exclusionOrg
      } = newListState[data.kaishaCd + data.shainId];
      newListState[data.kaishaCd + data.shainId] = _objectSpread(_objectSpread({}, newListState[data.kaishaCd + data.shainId]), {}, {
        isChange: action.payload.exclusion !== exclusionOrg,
        exclusion: action.payload.exclusion,
        exclusionOrg: exclusionOrg
      });
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listState: newListState
    });
  },
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE),
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  })
}, INIT_STATE);